export default __webpack_public_path__ + "ee41e9145db28bb9bf59e7447b4e09d6.png";